"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function CoreBelief() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="232477" id="minimalspacer" className="bg-background py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-4 md:px-8 lg:px-16">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        </div>
      </div>
    </section>;
}